import { useGetGuidParam } from '@risksmart-app/components/src/routes/routes.utils';
import { Parent_Type_Enum } from '@risksmart-app/web-graphql-client/generated/graphql';
import type { FC } from 'react';
import { ObjectToolbar } from 'src/blocks/object-toolbar';
import ControlledTabs from 'src/components/controlled-tabs/ControlledTabs';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import useTabs from '@/hooks/useTabs';
import { policyDetailsUrl } from '@/utils/urls';

import { PageLayout } from '../../../../../../layouts';

const DocumentFileModal: FC = () => {
  const parentDocumentId = useGetGuidParam('documentId');
  const objectToolbarEnabled = useIsFeatureFlagEnabled('object_toolbar');
  const title = 'Create Document Version';
  const tabs = useTabs({
    parentType: Parent_Type_Enum.DocumentFile,
    parent: undefined,
    hrefRoot: policyDetailsUrl(parentDocumentId),
    disabled: true,
  });

  return (
    <PageLayout
      title={title}
      // Title-only object toolbar (CUS-166) — flag-gated. The version form keeps
      // its own Create/Cancel controls, so no save disc or actions here.
      headerOverride={
        objectToolbarEnabled ? (
          <ObjectToolbar config={{ header: { title } }} />
        ) : undefined
      }
    >
      <ControlledTabs
        activeTabId={'details'}
        tabs={tabs}
        variant={'container'}
        parentType={Parent_Type_Enum.DocumentFile}
        disableSettings
      />
    </PageLayout>
  );
};

export default DocumentFileModal;
